module.exports = __webpack_public_path__ + "static/media/extherm.4c73db90.pdf";